'use client';

import { Typography, BottomSheet, Button, useOverlay } from '@bgzt/ui';
import { Spacing } from '~/components';

import styles from './useReviewGuideBottomSheet.module.css';

type ReviewGuide = {
  title: string;
  contents: string[];
};

export const useReviewGuideBottomSheet = (guide?: ReviewGuide) => {
  const overlay = useOverlay();

  const openReviewGuideBottomSheet = () => {
    overlay.open(({ isOpen, close }) => (
      <BottomSheet isOpen={isOpen} onClose={close}>
        <Typography variant="T4" color="gray-900">
          {guide?.title}
        </Typography>

        <Spacing height={20} />

        <ul className={styles.infoList}>
          {guide?.contents.map((item, index) => (
            <li key={index} className={styles.infoItem}>
              <Typography variant="B5" color="gray-800" className={styles.infoItemText}>
                {item}
              </Typography>
            </li>
          ))}
        </ul>

        <BottomSheet.Footer showTopGradient>
          <Button width={'100%'} size="xlarge" variant="normalGray" onClick={close}>
            닫기
          </Button>
        </BottomSheet.Footer>
      </BottomSheet>
    ));
  };

  return openReviewGuideBottomSheet;
};
